import { gql } from '@apollo/client'

const UPDATE_DISH_TYPE_EXTRA_DETAILS_MUTATION = gql`
  mutation updateIngredientExtraDetails(
    $id: ID!
    $data: IngredientExtraDetailsInput!
  ) {
    updateIngredientExtraDetails(id: $id, data: $data) {
      id
      updatedAt

      updatedBy {
        id
        name
      }

      phrases {
        id
        phrase
        type
      }

      extraIngredients {
        id
        type
      }
    }
  }
`

export default UPDATE_DISH_TYPE_EXTRA_DETAILS_MUTATION
